import { ICArea } from "./icarea";
import { ICContent } from "./iccontent";
import { ICFolderRelation } from "./icfolderrelation";
import { Translation } from "./translation";

export class ICFolder {
  Childrens: ICFolderRelation[];
  Client: ICArea;
  Code: string;
  Contents: ICContent[];
  DeleteDate: string;
  Fathers: ICFolderRelation[];
  Id: number;
  IdGuid: string;
  InsertDate: string;
  LastEditDate: string;
  Name: Translation[];
  Order: number;

  constructor(data?: Partial<ICFolder>) {
    Object.assign(this, data);
  }
}
